module.exports = __webpack_public_path__ + "img/registration.cea0d14.png";